import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

interface EditEventTitleDialogProps {
  open: boolean;
  initialTitle: string;
  onClose: () => void;
  onSave: (title: string) => void;
}

/**
 * Small dialog to edit the title of an existing (Continuous)EventTimeSlot after
 * creation. Pre-fills the current title and hands the new one back to the
 * caller, which persists it via the existing update-timeslot mutation.
 */
const EditEventTitleDialog = ({
  open,
  initialTitle,
  onClose,
  onSave,
}: EditEventTitleDialogProps) => {
  const [title, setTitle] = useState(initialTitle);

  // Re-sync the field whenever the dialog is (re)opened for a different event.
  useEffect(() => {
    if (open) setTitle(initialTitle);
  }, [open, initialTitle]);

  const handleSave = () => {
    const trimmed = title.trim();
    if (!trimmed) return;
    onSave(trimmed);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Titel bearbeiten</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Titel"
          margin="dense"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSave();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text">
          Abbrechen
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={!title.trim()}>
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditEventTitleDialog;
